import React, { useEffect } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
// @ts-ignore
import RightArrow from '../../assets/img/gray-arrow.svg'
// @ts-ignore
import { useTranslation } from 'react-i18next'
// @ts-ignore
import CheckmarkIcon from '../../assets/img/checkmark-icon.svg'
import { useAppDispatch, useAppSelector } from '../../store'
import { AppState, setPhoneTimerCount, setShowPhoneNumResend, setShowPhoneNumTimer } from '../../store/appSlice'
import { isValidPhoneNumber } from 'libphonenumber-js'
//
//
const PhoneNumberInput: React.FC<{
  id: string
  label?: string
  error?: boolean
  errorText?: any
  value?: string
  style?: React.CSSProperties
  disabled?: boolean
  resendOnclick?: () => void
  sendSms?: () => void
  onBlur?: (value: any) => void
  onChange?: (value: any, event: { countryCode: string; dialCode: string }) => void
  hideButtons?: boolean
}> = ({
  id,
  label = '',
  error = false,
  errorText,
  value,
  style,
  disabled = false,
  onBlur,
  resendOnclick,
  sendSms,
  onChange,
  hideButtons = false,
}) => {
  //
  const { t } = useTranslation()
  //
  const dipatch = useAppDispatch()
  //
  const { region, showPhoneNumTimer, showPhoneNumResend, phoneTimerCount } = useAppSelector(
    (root: { app: AppState }) => root.app,
  )
  //
  // resend sms count down timer
  useEffect(() => {
    //  start sms timer
    if (showPhoneNumTimer) {
      phoneTimerCount > 0 && setTimeout(() => dipatch(setPhoneTimerCount(phoneTimerCount - 1)), 1000)
    }
    // reset sms timer
    if (showPhoneNumTimer && phoneTimerCount === 0) {
      dipatch(setShowPhoneNumTimer(false))
      dipatch(setPhoneTimerCount(60))
      dipatch(setShowPhoneNumResend(true))
    }
    //
  }, [phoneTimerCount, showPhoneNumTimer, dipatch])
  //
  const checkPhoneNumberValidity = (phoneNumber: string | undefined) => {
    return isValidPhoneNumber(`+${phoneNumber}`)
  }
  //
  const isValidNumber = checkPhoneNumberValidity(value)
  //
  //
  return (
    <Wrapper $error={error} style={style} $disabled={showPhoneNumTimer ? true : disabled} id={id}>
      {label ? <Label $error={error}>{label}</Label> : null}

      <Block>
        <PhoneInput
          inputClass="react-phone-input__dropdown"
          country={region?.country_code?.toLowerCase() || 'ge'}
          value={value}
          onChange={(value: string, event: { countryCode: string; dialCode: string }) => {
            onChange?.(value, event)
          }}
          onBlur={onBlur}
          inputProps={{
            id,
            disabled,
          }}
        />

        {hideButtons === false && isValidNumber === true ? (
          <>
            {showPhoneNumResend ? (
              <ResendBtn
                onClick={() => [
                  resendOnclick?.(),
                  dipatch(setShowPhoneNumTimer(true)),
                  dipatch(setShowPhoneNumResend(false)),
                ]}
              >
                {t('Resend') as string}
              </ResendBtn>
            ) : !showPhoneNumTimer ? (
              <SendSMSBtn
                onClick={() => [
                  sendSms?.(),
                  dipatch(setShowPhoneNumTimer(true)),
                  dipatch(setShowPhoneNumResend(false)),
                ]}
              >
                {t('sendSms') as string}
              </SendSMSBtn>
            ) : null}

            {showPhoneNumTimer ? <Count>{phoneTimerCount}s</Count> : null}
          </>
        ) : null}
      </Block>

      {error ? (
        <ErrorMessage id={id} $error={error}>
          {errorText}
        </ErrorMessage>
      ) : null}
    </Wrapper>
  )
}
//
const Count = styled.div`
  font-size: 12px;
  width: fit-content;
  position: absolute;
  right: 23px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  user-select: none;
  pointer-events: none;
  color: ${Colors.primaryBlack};
`
const ResendBtn = styled.div`
  text-decoration: underline;
  padding-inline: 23px;
  font-size: 12px;
  width: fit-content;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  background-color: transparent;
  color: ${Colors.primaryBlack};
`

const SendSMSBtn = styled(ResendBtn)`
  /*  */
`

const Block = styled.div`
  position: relative;
`
const ErrorMessage = styled.div<{ $error: boolean }>`
  width: inherit;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  color: ${({ $error }) => ($error === true ? `${Colors.primaryRed}` : `${Colors.primaryGrey}`)};
  margin-top: 5px;
`
const Label = styled.label<{ $error: boolean }>`
  width: inherit;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 5px;
  text-align: left;
  padding-right: 25px;
  color: ${({ $error }) => ($error ? `${Colors.primaryRed}` : `${Colors.primaryGrey}`)};
`
const Wrapper = styled.div<{ $error: boolean; $disabled: boolean }>`
  user-select: ${({ $disabled }) => ($disabled ? `none` : `auto`)} !important;
  pointer-events: ${({ $disabled }) => ($disabled ? `none` : `auto`)} !important;
  /* opacity: ${({ $disabled }) => ($disabled ? `0.3` : `unset`)} !important; */

  display: block;

  width: 100%;

  .form-control:disabled {
    background-color: ${Colors.secondaryGrey} !important;
    color: ${Colors.primaryBlack} !important;
    cursor: not-allowed !important;
    opacity: 0.7 !important;
  }

  ${({ $disabled }) =>
    $disabled &&
    `
  .flag-dropdown,
  .selected-flag {
    pointer-events: none !important;
    background-color: ${Colors.secondaryGrey} !important;
    opacity: 0.7 !important;
    cursor: not-allowed !important;
  }

  .form-control {
    background-color: ${Colors.secondaryGrey} !important;
    cursor: not-allowed !important;
  }
`}

  .country-name {
    display: none;
  }

  .react-tel-input .country-list .country.highlight {
    background-color: ${Colors.lightGrey};
  }

  .country-list {
    width: 100% !important;
    max-height: 180px !important;
    padding-block: 12px !important;
    border-radius: 4px !important;
    box-shadow: unset !important;
    border: 1px solid ${Colors.rollingStone} !important;
    margin-top: 12px !important;

    li {
      padding-left: 12px !important;
      height: 40px;
      margin-inline: 10.5px;
      border-radius: 4px;
      font-size: 14px;

      .dial-code {
        color: ${Colors.primaryBlack} !important;
      }

      &:hover {
        background-color: ${Colors.lightGrey} !important;
      }
    }
  }

  .react-tel-input {
    display: flex;
    font-family: inherit !important;
  }

  .form-control {
    order: 2;
    transition: unset !important;
  }

  .form-control.react-phone-input__dropdown {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    padding-left: 5px;
  }

  .react-tel-input .flag {
    transform: scale(1.3);
  }

  .arrow {
    width: 10px !important;
    height: 10px !important;
    border: unset !important;
    background-image: url(${RightArrow});
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute !important;
    top: 3px !important;
    left: 24px !important;
  }

  .arrow.up {
    transform: rotate(180deg);
  }

  .form-control:focus {
    box-shadow: unset;
  }

  .react-tel-input .flag-dropdown.open .selected-flag {
    border-radius: 4px !important;
  }

  .react-tel-input .flag-dropdown.open {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }

  .react-tel-input {
    &:hover {
      .flag-dropdown {
        border-color: ${({ $error }) => ($error ? `${Colors.primaryRed}` : `${Colors.primaryBlack}`)} !important;
      }

      input {
        border-color: ${({ $error }) => ($error ? `${Colors.primaryRed}` : `${Colors.primaryBlack}`)} !important;
      }
    }
  }

  input {
    box-shadow: unset;
    border-color: ${({ $error }) => ($error ? `${Colors.primaryRed}` : `${Colors.secondaryGrey}`)} !important;
    border-left: unset !important;
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  .country.highlight {
    background-image: url(${CheckmarkIcon});
    background-repeat: no-repeat;
    background-position-x: calc(100% - 10px);
    background-position-y: center;
  }

  .flag-dropdown {
    order: 1 !important;
    height: 48px !important;
    position: unset !important;
    border-radius: 4px 0px 0px 4px !important;
    border-right: unset !important;
    border-color: ${({ $error }) => ($error ? `${Colors.primaryRed}` : `${Colors.secondaryGrey}`)} !important;

    &::before {
      position: absolute;
      z-index: 1;
      content: '|' !important;
      color: ${Colors.Geyser} !important;
      left: 74px;
      top: 12px;
    }

    .selected-flag {
      background-color: ${Colors.white};
      width: 80px;

      padding: 0px;
      .flag {
        margin-left: 23px;
      }
    }
  }
`
//
export default PhoneNumberInput
